import { useQuery } from "@tanstack/react-query";

import { getReportingProjects } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { REPORTING_QUERY_KEYS } from "./queryKeys";

export function useReportingProjectsQuery() {
  return useQuery({
    queryKey: REPORTING_QUERY_KEYS.projects(),
    queryFn: processResponse(() => getReportingProjects()),
    staleTime: 5 * 60 * 1000,
  });
}
